import { SafeHydrate } from "@/SafeHydrate";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { Calendar } from "lucide-react";
export default function PremiumMedicalHero() {
  return <section data-section-id="252611" id="premiummedicalhero" className="relative bg-background text-foreground py-24 lg:py-32 overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img src="https://stable-sturgeon.10web.cloud/wp-content/uploads/2026/04/Bodyconcept_linda_bewei-face.webp" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1642411/img/bewei_face_treatment_overlay.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1642411/img/bewei_face_treatment_overlay.png-wvc-sizes" alt="Premium Facial Treatment" className="w-full h-full object-cover opacity-40 !bg-[rgba(150,233,217,0.46)]" loading="lazy" />
        <div className="absolute inset-0 mix-blend-overlay !bg-[rgba(226,255,251,1)]"></div>
      </div>

      <div className="relative z-10 page-container">
        <div className="max-w-3xl pl-4 md:pl-8 lg:pl-12">
          <h2 className="text-sm font-default font-semibold tracking-widest uppercase mb-4 !text-[rgba(33,140,144,1)] md:text-base">
            BEWEI FACE - MILDERUNG VON Fältchen, Tränensäcken, Doppelkinn, Gesichtskontur
          </h2>
          <h1 className="font-default leading-tight mb-6 tracking-wider !text-[rgba(17,96,85,1)] !text-[55px] !font-semibold">BEWEI FACE LÄSST OHNE INJEKTION GESICHT &amp; DEKOLLETÉ JÜNGER WIRKEN</h1>
          <p className="text-lg md:text-[20px] font-sans mb-10 text-muted-foreground max-w-2xl">
            Erleben Sie die sanfte Revolution der Hautverjüngung. Unsere innovative Technologie aktiviert natürliche Prozesse für ein strahlendes, gefestigtes Erscheinungsbild ganz ohne Nadeln.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <a href="https://wa.me/491713617469" target="_blank" className="inline-flex items-center justify-center bg-primary text-white px-8 py-3 rounded-lg font-medium transition-all hover:bg-primary/90">
              <SafeHydrate><Calendar className="mr-2 h-5 w-5" /></SafeHydrate>
              Termin vereinbaren
            </a>
          </div>
        </div>
      </div>
    </section>;
}